
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(335|940)1$/.test(chunkId);
},
rootOutputDir: "",

    };
}
